<template>
 
    
      <iframe
        :src="iframeUrl"
        width="100%"
        height="800"
        frameborder="0"
        scrolling="auto"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        class="financial-overview-iframe"
      >
        <p>Your browser does not support iframes. Please visit the financial overview directly.</p>
      </iframe>
   
 
</template>

<script>
import AuthService from "@/auth/authService";

export default {
  name: "FinancialOverview",
  data() {
    return {
      authService: AuthService.getInstance()
    };
  },
  computed: {
    tenantId() {
      // Get tenant ID from Auth0 user object via the custom claim
      if (this.$auth && this.$auth.user && this.$auth.user["https://snapsuite_tenantId"]) {
        return this.$auth.user["https://snapsuite_tenantId"];
      }
      return 'default';
    },
    iframeUrl() {
      // Use the full auth query string instead of just tenant ID
      const authQueryString = this.authService.getQueryString();
      
      // If we have auth parameters, use the Cloudflare Worker with full auth
      if (authQueryString) {
        const baseUrl = 'https://jupiter-expense-overview.snapsuite.workers.dev/';
        return `${baseUrl}${authQueryString}`;
      }
      
      // Fallback to basic tenant-only URL
      const baseUrl = 'https://jupiter-expense-overview.snapsuite.workers.dev/';
      return `${baseUrl}?t=${this.tenantId}`;
    }
  },
  mounted() {
    // Optional: Track page view if analytics are enabled
    if (process.env.VUE_APP_ENVIRONMENT === "production") {
      // window.analytics?.page("Financial Overview");
    }
  }
};
</script>

<style scoped>
.financial-overview-container {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  background: white;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.financial-overview-iframe {
  display: block;
  border: none;
  min-height: 600px;
}

/* Loading state styles */
.iframe-wrapper::before {
  content: 'Loading Financial Overview...';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #6c757d;
  font-size: 16px;
  z-index: 1;
}

/* Hide loading text once iframe loads */
.financial-overview-iframe:not([src=""]) + .iframe-wrapper::before {
  display: none;
}
</style>
